var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yandex-map',{attrs:{"settings":_vm.settings,"coords":_vm.center,"zoom":_vm.zoom,"controls":_vm.controls,"ymap-class":"ymap-calc"},on:{"update:zoom":function($event){_vm.zoom=$event},"map-was-initialized":_vm.mapLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }